"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceTypeMap = void 0;
// @todo keep this temporarily until src/server/source-util is removed
exports.sourceTypeMap = {
    SURVEY: "survey" /* SURVEY */,
    FIELDSET: "fieldset" /* FIELDSET */
};
